<template>
  <div class="tw:border-l tw:border-default-200 tw:flex-1">
    <div class="tw:p-3 tw:flex tw:gap-1 tw:flex-col">
      <p class="tw:body-2 tw:text-black">{{ label }}</p>

      <EdroneSkeletonLoader v-if="isLoading" class="tw:w-[7.5rem] tw:h-[2.5rem]" />

      <p v-else class="tw:heading-1 tw:text-black">{{ value ?? "-" }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import EdroneSkeletonLoader from "edrone-components/EdroneSkeletonLoader.vue";

interface Props {
  label: string;
  value: string | number | null;
  isLoading: boolean;
}

defineProps<Props>();
</script>
